import React, { useRef } from "react";
import ReactToPrint from "react-to-print";
import PrintHeader from "./PrintHeader"; // Import PrintHeader

const PrintActionCardSenco = ({
  cardPosition,
  handleCloseCard,
  activeAccordionRef,
  className,
  academicYear,
  assessmentName
}) => {
  const printCardRef = useRef(null);
  const printContainerRef = useRef(null);

  return (
    <>
      <div
        ref={printCardRef}
        className="action-card"
        style={{
          position: "absolute",
          top: `${cardPosition.top}px`,
          left: `${cardPosition.left}px`,
          zIndex: 1000,
          width: "180px",
          padding: "16px", // Ensure consistent padding
        }}
      >
        <div className="action-card-header" style={{ marginBottom: "16px" }}>
          <p className="action-header">Print</p>
          <button onClick={handleCloseCard} className="close-button">
            ✕
          </button>
        </div>
        <div className="action-card-body">
          <ReactToPrint
            trigger={() => (
              <button
                className="blue-action-button"
                style={{ marginBottom: "16px" }}
              >
                Current View
              </button>
            )}
            content={() => printContainerRef.current}
          />
        </div>
      </div>
      {/* Hidden print container */}
      <div style={{ display: "none" }}>
        <div ref={printContainerRef}>
          <PrintHeader className={className} academicYear={academicYear} assessmentName={assessmentName}/>
          {/* Render the content of the active accordion */}
          <div>
            {activeAccordionRef.current &&
            activeAccordionRef.current.outerHTML ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: activeAccordionRef.current.outerHTML,
                }}
              />
            ) : null}
          </div>
          {/* <div
            className="alpaca-print-footer"
            style={{
              position: "fixed",
              left: 0,
              bottom: 0,
              width: "100%",
              textAlign: "center",
              fontSize: "0.9rem",
              color: "#888",
              padding: "8px 0",
              background: "white",
              zIndex: 1000,
            }}
          >
            Powered by ALPACA &copy; {new Date().getFullYear()}
          </div> */}
        </div>
      </div>
    </>
  );
};

export default PrintActionCardSenco;
